import { defineQuery, useQuery } from '@pinia/colada'
import { services } from '~/services/composition'

export const useAccountsQuery = defineQuery(() => {
  const query = useQuery({
    key: () => ['accounts'],
    query: () => services.accounts.getAccounts(),
    staleTime: 60_000
  })

  return {
    ...query
  }
})
